export function HomePage() {
    return (
        <>
            {/* Hero Section */}
            <section className="hero-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="hero-content">
                                <h1 className="display-4 fw-bold mb-4">
                                    Enterprise Content Management
                                </h1>
                                <p className="lead mb-4">
                                    Store your files anywhere. View and manage them from Salesforce. 
                                    Reduce costs while maintaining compliance and security.
                                </p>
                                <div className="d-flex gap-3 flex-wrap">
                                    <a 
                                        className="btn btn-modern btn-lg" 
                                        href="https://www.arcanescale.com/#services" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                    >
                                        Learn More
                                    </a>
                                    <a className="btn btn-outline-modern btn-lg" href="/login">
                                        Get Started
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 mt-5 mt-lg-0">
                            <div className="text-center">
                                <img 
                                    src="/main.jpg" 
                                    className="img-fluid rounded-3 shadow-lg" 
                                    alt="Arcane Scale Enterprise Content Management"
                                    style={{maxHeight: '400px', objectFit: 'cover'}}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Features Section */}
            <section className="py-5 bg-light">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 mx-auto text-center mb-5">
                            <h2 className="display-5 fw-semibold mb-3">
                                Why Choose Arcane ECM?
                            </h2>
                            <p className="lead text-muted">
                                Comprehensive enterprise content management designed for modern businesses
                            </p>
                        </div>
                    </div>
                    <div className="row g-4">
                        <div className="col-md-6 col-lg-3">
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <i className="bi bi-cloud-arrow-up"></i>
                                </div>
                                <h3>Cost Reduction</h3>
                                <p>
                                    Store or move files outside of Salesforce to significantly reduce storage costs
                                    while maintaining full functionality.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <i className="bi bi-shield-check"></i>
                                </div>
                                <h3>Compliance Ready</h3>
                                <p>
                                    Store files in your preferred cloud provider or on-prem systems to comply 
                                    with various regulations and audit requirements.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <i className="bi bi-graph-up"></i>
                                </div>
                                <h3>Advanced Analytics</h3>
                                <p>
                                    Leverage your unified enterprise store for downstream processing capabilities 
                                    including ML and advanced analytics.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <i className="bi bi-diagram-3"></i>
                                </div>
                                <h3>System Integration</h3>
                                <p>
                                    Seamlessly integrate with Financial Core Systems, EMR/EHR, ERP, 
                                    and other enterprise applications.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Supported Platforms Section */}
            <section className="py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 mx-auto text-center">
                            <h3 className="fw-semibold mb-4">Supported Platforms</h3>
                            <p className="text-muted mb-4">
                                Connect to your preferred cloud provider or storage system
                            </p>
                            <div className="d-flex flex-wrap justify-content-center gap-4 align-items-center">
                                <span className="badge bg-light text-dark border px-3 py-2">AWS S3</span>
                                <span className="badge bg-light text-dark border px-3 py-2">Google Cloud Storage</span>
                                <span className="badge bg-light text-dark border px-3 py-2">Azure Blob</span>
                                <span className="badge bg-light text-dark border px-3 py-2">Box</span>
                                <span className="badge bg-light text-dark border px-3 py-2">SharePoint</span>
                                <span className="badge bg-light text-dark border px-3 py-2">Dropbox</span>
                                <span className="badge bg-light text-dark border px-3 py-2">On-Premises</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}